import { FaRegStar, FaStar } from "react-icons/fa"

export default function PreguntaLinealV2({item, onHandleLinealAnswer, checkLinealStado}){
    
    return(
        <>
            <label className="colorLabel mb-1">{item.title}</label>
            <div className="d-flex justify-content-center align-items-center">
                {
                    item.options.map((it, i)=>(
                        <div key={`preguntaLineal-${i}`} onClick={e=>onHandleLinealAnswer(it, item)} className="text-center">
                            <div className="mx-2">
                                {
                                    checkLinealStado.filter(e=>e.id===item.id).length > 0 &&
                                    checkLinealStado.filter(e=>e.id===item.id)[0].options[0]===it ? 
                                    <FaStar className="fs-1--2 cursor-pointer" fill="#F5972A" /> : 
                                    <FaRegStar className="fs-1--2 cursor-pointer" fill="#F5972A" />
                                }                                
                            </div>
                            <div>
                                {it}
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}